import React, { useState } from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
    FaBusAlt,
    FaUserTie,
    FaClock,
    FaMapMarkerAlt,
    FaPhoneAlt,
} from "react-icons/fa";

import {
    useParams,
    Link,
} from "react-router-dom";

const TransportDetails = () => {

    const { id } = useParams();

    const [open, setOpen] =
        useState(false);

    const transportData = {

        "vehicle-1-trip-1": {

            title: "VEHICLE NO.1 TRIP NO.1",
            route: "Sinduriya",
            driver: "Allauddin",
            mobile: "9956585595",
            busNo: "UP56TO112",
            morningTrip: "First Trip",
            eveningTrip: "First Trip",

            stops: [

                {
                    sn: 1,
                    stoppage: "Sinduriya Bazar",
                    km: "11 Km",
                    morning: "6:20 AM",
                    evening: "2:46 PM",
                },

                {
                    sn: 2,
                    stoppage: "Patrengwa",
                    km: "10 Km",
                    morning: "6:25 AM",
                    evening: "2:40 PM",
                },

                {
                    sn: 3,
                    stoppage: "Bauliya Raja",
                    km: "6 Km",
                    morning: "6:30 AM",
                    evening: "2:30 PM",
                },

                {
                    sn: 4,
                    stoppage: "Mundera Kala",
                    km: "5 Km",
                    morning: "6:32 AM",
                    evening: "2:32 PM",
                },

                {
                    sn: 5,
                    stoppage: "Police Line",
                    km: "4 Km",
                    morning: "6:36 AM",
                    evening: "2:23 PM",
                },

                {
                    sn: 6,
                    stoppage: "Dhanewa-Dhanei",
                    km: "2 Km",
                    morning: "6:39 AM",
                    evening: "2:18 PM",
                },

            ],

        },

        "vehicle-1-trip-2": {

            title: "VEHICLE NO.1 TRIP NO.2",
            route: "Babhanawli",
            driver: "Allauddin",
            mobile: "9956585595",
            busNo: "UP56TO112",
            morningTrip: "Second Trip",
            eveningTrip: "Second Trip",

            stops: [

                {
                    sn: 1,
                    stoppage: "Babhnawli",
                    km: "12 Km",
                    morning: "7:32 AM",
                    evening: "3:40 PM",
                },

                {
                    sn: 2,
                    stoppage: "Mudila Tiwari",
                    km: "12 Km",
                    morning: "7:39 AM",
                    evening: "3:44 PM",
                },

                {
                    sn: 3,
                    stoppage: "Khempipra",
                    km: "7 Km",
                    morning: "7:43 AM",
                    evening: "3:39 PM",
                },

                {
                    sn: 4,
                    stoppage: "Baspar Baijoli",
                    km: "6 Km",
                    morning: "7:46 AM",
                    evening: "3:36 PM",
                },

                {
                    sn: 5,
                    stoppage: "Padri Road",
                    km: "3 Km",
                    morning: "7:55 AM",
                    evening: "3:28 PM",
                },

                {
                    sn: 6,
                    stoppage: "Azad Nagar",
                    km: "2 Km",
                    morning: "8:10 AM",
                    evening: "3:25 PM",
                },

                {
                    sn: 7,
                    stoppage: "Chowk Road",
                    km: "2 Km",
                    morning: "8:11 AM",
                    evening: "3:25 PM",
                },

                {
                    sn: 8,
                    stoppage: "Balaji Hospital",
                    km: "2 Km",
                    morning: "8:12 AM",
                    evening: "3:22 PM",
                },

                {
                    sn: 9,
                    stoppage: "Maupakar Mandi",
                    km: "2 Km",
                    morning: "8:13 AM",
                    evening: "3:21 PM",
                },

            ],

        },

        "vehicle-2-trip-1": {

            title: "VEHICLE NO.2 TRIP NO.1",
            route: "Chowk",
            driver: "Kishor Gaur",
            mobile: "9565023651",
            busNo: "UP56TO178",
            morningTrip: "First Trip",
            eveningTrip: "Second Trip",

            stops: [

                {
                    sn: 1,
                    stoppage: "Pipra Sonari",
                    km: "15 Km",
                    morning: "6:30 AM",
                    evening: "4:10 PM",
                },

                {
                    sn: 2,
                    stoppage: "Nandabhar",
                    km: "12 Km",
                    morning: "6:35 AM",
                    evening: "4:17 PM",
                },

                {
                    sn: 3,
                    stoppage: "Khajuriya",
                    km: "11 Km",
                    morning: "6:45 AM",
                    evening: "4:25 PM",
                },

                {
                    sn: 4,
                    stoppage: "Chowk",
                    km: "12 Km",
                    morning: "7:00 AM",
                    evening: "4:00 PM",
                },

                {
                    sn: 5,
                    stoppage: "Darhata",
                    km: "8 Km",
                    morning: "7:15 AM",
                    evening: "3:47 PM",
                },

                {
                    sn: 6,
                    stoppage: "Kashmariya",
                    km: "8 Km",
                    morning: "7:25 AM",
                    evening: "3:38 PM",
                },

                {
                    sn: 7,
                    stoppage: "Janjanpur",
                    km: "7 Km",
                    morning: "7:33 AM",
                    evening: "3:32 PM",
                },

                {
                    sn: 8,
                    stoppage: "Arnahwa",
                    km: "6 Km",
                    morning: "7:35 AM",
                    evening: "3:30 PM",
                },

                {
                    sn: 9,
                    stoppage: "Baijnthapur",
                    km: "6 Km",
                    morning: "7:37 AM",
                    evening: "3:29 PM",
                },

                {
                    sn: 10,
                    stoppage: "Ashokwa",
                    km: "5 Km",
                    morning: "7:40 AM",
                    evening: "3:26 PM",
                },

                {
                    sn: 11,
                    stoppage: "Siswaniya",
                    km: "5 Km",
                    morning: "7:44 AM",
                    evening: "3:22 PM",
                },

                {
                    sn: 12,
                    stoppage: "Sonra",
                    km: "3 Km",
                    morning: "7:46 AM",
                    evening: "3:20 PM",
                },

                {
                    sn: 13,
                    stoppage: "Maharajganj",
                    km: "2 Km",
                    morning: "8:00 AM",
                    evening: "3:10 PM",
                },

            ],

        },

        "vehicle-2-trip-2": {

            title: "VEHICLE NO.2 TRIP NO.2",
            route: "Kotwali Road",
            driver: "Kishor Gaur",
            mobile: "9565023651",
            busNo: "UP56TO178",
            morningTrip: "Second Trip",
            eveningTrip: "First Trip",

            stops: [

                {
                    sn: 1,
                    stoppage: "Kotwali Road",
                    km: "2 Km",
                    morning: "8:10 AM",
                    evening: "2:45 PM",
                },

                {
                    sn: 2,
                    stoppage: "Main Chauraha",
                    km: "2 Km",
                    morning: "8:12 AM",
                    evening: "2:40 PM",
                },

                {
                    sn: 3,
                    stoppage: "Nagar Palika Gate",
                    km: "2 Km",
                    morning: "8:14 AM",
                    evening: "2:35 PM",
                },

                {
                    sn: 4,
                    stoppage: "PWD Gate",
                    km: "2 Km",
                    morning: "8:16 AM",
                    evening: "2:32 PM",
                },

                {
                    sn: 5,
                    stoppage: "Abkari Gate",
                    km: "2 Km",
                    morning: "8:15 AM",
                    evening: "2:33 PM",
                },

                {
                    sn: 6,
                    stoppage: "Bus Stand",
                    km: "2 Km",
                    morning: "8:17 AM",
                    evening: "2:31 PM",
                },

                {
                    sn: 7,
                    stoppage: "MauPakar",
                    km: "2 Km",
                    morning: "8:20 AM",
                    evening: "2:20 PM",
                },

            ],

        },
        "vehicle-3-trip-1": {

            title: "VEHICLE NO.3 TRIP NO.1",
            route: "Bagapar",
            driver: "Chote Lal",
            mobile: "8546069916",
            busNo: "UP56TO635",
            morningTrip: "First Trip",
            eveningTrip: "Second Trip",

            stops: [

                {
                    sn: 1,
                    stoppage: "Belahiya",
                    km: "12 Km",
                    morning: "6:00 AM",
                    evening: "4:14 PM",
                },

                {
                    sn: 2,
                    stoppage: "Basantpur",
                    km: "13 Km",
                    morning: "6:05 AM",
                    evening: "4:20 PM",
                },

                {
                    sn: 3,
                    stoppage: "Barwa Raja",
                    km: "14 Km",
                    morning: "6:15 AM",
                    evening: "4:07 PM",
                },

                {
                    sn: 4,
                    stoppage: "Sadkahiya",
                    km: "12 Km",
                    morning: "6:20 AM",
                    evening: "4:03 PM",
                },

                {
                    sn: 5,
                    stoppage: "Bagapar",
                    km: "12 Km",
                    morning: "6:30 AM",
                    evening: "3:56 PM",
                },

                {
                    sn: 6,
                    stoppage: "Janakpur",
                    km: "9 Km",
                    morning: "6:35 AM",
                    evening: "3:53 PM",
                },

                {
                    sn: 7,
                    stoppage: "Lakhima",
                    km: "5 Km",
                    morning: "6:50 AM",
                    evening: "3:42 PM",
                },

                {
                    sn: 8,
                    stoppage: "Rampur",
                    km: "5 Km",
                    morning: "6:40 AM",
                    evening: "3:41 PM",
                },

            ],

        },

        "vehicle-3-trip-2": {

            title: "VEHICLE NO.3 TRIP NO.2",
            route: "Baspar Road",
            driver: "Chote Lal",
            mobile: "8546069916",
            busNo: "UP56TO635",
            morningTrip: "Second Trip",
            eveningTrip: "First Trip",

            stops: [

                {
                    sn: 1,
                    stoppage: "Indeera Nagar",
                    km: "2 Km",
                    morning: "7:30 AM",
                    evening: "2:52 PM",
                },

                {
                    sn: 2,
                    stoppage: "Shubash Nagar",
                    km: "2 Km",
                    morning: "7:35 AM",
                    evening: "2:50 PM",
                },

                {
                    sn: 3,
                    stoppage: "Ambedkar Nagar",
                    km: "2 Km",
                    morning: "7:38 AM",
                    evening: "2:49 PM",
                },

                {
                    sn: 4,
                    stoppage: "Patel Nagar",
                    km: "2 Km",
                    morning: "7:40 AM",
                    evening: "2:48 PM",
                },

                {
                    sn: 5,
                    stoppage: "Sastri Nagar",
                    km: "3 Km",
                    morning: "7:41 AM",
                    evening: "2:47 PM",
                },

                {
                    sn: 6,
                    stoppage: "Bismil Nagar",
                    km: "2 Km",
                    morning: "7:45 AM",
                    evening: "2:40 PM",
                },

                {
                    sn: 7,
                    stoppage: "Azad Nagar",
                    km: "2 Km",
                    morning: "7:52 AM",
                    evening: "2:30 PM",
                },

            ],

        },

        "vehicle-4-trip-2": {

            title: "VEHICLE NO.4 TRIP NO.2",
            route: "Baikunth Pur",
            driver: "Amarjeet",
            mobile: "7705875243",
            busNo: "UP56T2499",
            morningTrip: "Second Trip",
            eveningTrip: "First Trip",

            stops: [

                {
                    sn: 1,
                    stoppage: "Pipra Babu",
                    km: "5 Km",
                    morning: "8:00 AM",
                    evening: "2:40 PM",
                },

                {
                    sn: 2,
                    stoppage: "Baikunth Pur",
                    km: "4 Km",
                    morning: "8:05 AM",
                    evening: "2:38 PM",
                },

                {
                    sn: 3,
                    stoppage: "LIC Office",
                    km: "4 Km",
                    morning: "8:07 AM",
                    evening: "3:36 PM",
                },

                {
                    sn: 4,
                    stoppage: "Shiv Nagar",
                    km: "3 Km",
                    morning: "8:10 AM",
                    evening: "2:34 PM",
                },

                {
                    sn: 5,
                    stoppage: "Petrol Pump",
                    km: "3 Km",
                    morning: "8:15 AM",
                    evening: "2:32 PM",
                },

                {
                    sn: 6,
                    stoppage: "Hanumangarh",
                    km: "2 Km",
                    morning: "8:20 AM",
                    evening: "2:30 PM",
                },

            ],

        },

        "vehicle-4-trip-1": {

            title: "VEHICLE NO.4 TRIP NO.1",
            route: "Pakari Range",
            driver: "Amarjeet",
            mobile: "7705875243",
            busNo: "UP56T2499",
            morningTrip: "First Trip",
            eveningTrip: "Second Trip",

            stops: [

                {
                    sn: 1,
                    stoppage: "Pakari Range",
                    km: "11 Km",
                    morning: "7:00 AM",
                    evening: "3:45 PM",
                },

                {
                    sn: 2,
                    stoppage: "Rudra Pur",
                    km: "7 Km",
                    morning: "7:07 AM",
                    evening: "3:37 PM",
                },

                {
                    sn: 3,
                    stoppage: "Mahuawa Dhala",
                    km: "6 Km",
                    morning: "7:10 AM",
                    evening: "3:35 PM",
                },

                {
                    sn: 4,
                    stoppage: "Chaupariya",
                    km: "5 Km",
                    morning: "7:12 AM",
                    evening: "3:33 PM",
                },

                {
                    sn: 5,
                    stoppage: "Mukhyalaya",
                    km: "4 Km",
                    morning: "7:15 AM",
                    evening: "3:28 PM",
                },

                {
                    sn: 6,
                    stoppage: "Dist. Hospital",
                    km: "4 Km",
                    morning: "7:20 AM",
                    evening: "3:23 PM",
                },

                {
                    sn: 7,
                    stoppage: "Tedhwa Kutti",
                    km: "4 Km",
                    morning: "7:05 AM",
                    evening: "3:20 PM",
                },

                {
                    sn: 8,
                    stoppage: "Shastri Nagar",
                    km: "3 Km",
                    morning: "7:27 AM",
                    evening: "3:19 PM",
                },

                {
                    sn: 9,
                    stoppage: "Rajiv Nagar",
                    km: "3 Km",
                    morning: "7:28 AM",
                    evening: "3:18 PM",
                },

                {
                    sn: 10,
                    stoppage: "Officer Colony",
                    km: "3 Km",
                    morning: "7:30 AM",
                    evening: "3:15 PM",
                },

                {
                    sn: 11,
                    stoppage: "State Bank",
                    km: "3 Km",
                    morning: "7:35 AM",
                    evening: "3:13 PM",
                },

                {
                    sn: 12,
                    stoppage: "Block",
                    km: "2 Km",
                    morning: "7:37 AM",
                    evening: "3:10 PM",
                },

            ],

        },

        "vehicle-5-trip-1": {

            title: "VEHICLE NO.5 TRIP NO.1",
            route: "Puraina Khandi",
            driver: "Shah Alam",
            mobile: "7068125412",
            busNo: "UP56T5876",
            morningTrip: "First Trip",
            eveningTrip: "Second Trip",

            stops: [

                {
                    sn: 1,
                    stoppage: "Puraina Khandi",
                    km: "15 Km",
                    morning: "7:15 AM",
                    evening: "3:35 PM",
                },

                {
                    sn: 2,
                    stoppage: "Belwa Tikar",
                    km: "13 Km",
                    morning: "7:20 AM",
                    evening: "3:28 PM",
                },

                {
                    sn: 3,
                    stoppage: "Barwa Khurd",
                    km: "11 Km",
                    morning: "7:24 AM",
                    evening: "3:00 PM",
                },

                {
                    sn: 4,
                    stoppage: "Parsa Gidahi",
                    km: "13 Km",
                    morning: "7:29 AM",
                    evening: "3:05 PM",
                },

                {
                    sn: 5,
                    stoppage: "Pakari Siswa",
                    km: "15 Km",
                    morning: "7:32 AM",
                    evening: "3:13 PM",
                },

                {
                    sn: 6,
                    stoppage: "Shikarpur",
                    km: "9 Km",
                    morning: "7:38 AM",
                    evening: "2:55 PM",
                },

                {
                    sn: 7,
                    stoppage: "Barwa Vidyapati",
                    km: "8 Km",
                    morning: "7:41 AM",
                    evening: "2:51 PM",
                },

                {
                    sn: 8,
                    stoppage: "Satbhariya",
                    km: "7 Km",
                    morning: "7:44 AM",
                    evening: "2:47 PM",
                },

                {
                    sn: 9,
                    stoppage: "Rampurwa",
                    km: "6 Km",
                    morning: "7:46 AM",
                    evening: "2:44 PM",
                },

                {
                    sn: 10,
                    stoppage: "Mujahana Khurd",
                    km: "5 Km",
                    morning: "7:50 AM",
                    evening: "2:34 PM",
                },

                {
                    sn: 11,
                    stoppage: "Siswa Babu",
                    km: "6 Km",
                    morning: "7:53 AM",
                    evening: "2:40 PM",
                },

            ],

        },

    };

    const vehicle =
        transportData[id];

    if (!vehicle) {

        return (

            <>
                <Header
                    toggleSidebar={() =>
                        setOpen(true)
                    }
                />

                <Sidebar
                    isOpen={open}
                    close={() =>
                        setOpen(false)
                    }
                />

                <section className="min-h-screen bg-[#f7f9fc] flex items-center justify-center">

                    <div className="text-center">

                        <h1 className="text-4xl font-bold text-[#072F5F] mb-4">

                            Vehicle Not Found

                        </h1>

                        <Link
                            to="/transport"
                            className="inline-block mt-4 bg-[#0B4F9C] text-white px-8 py-3 rounded-xl font-semibold hover:bg-[#072F5F] transition-all duration-300"
                        >

                            Back To Transport

                        </Link>

                    </div>

                </section>

                <Footer />
            </>
        );
    }

    return (

        <>
            <Header
                toggleSidebar={() =>
                    setOpen(true)
                }
            />

            <Sidebar
                isOpen={open}
                close={() =>
                    setOpen(false)
                }
            />

            <section className="w-full bg-[#f7f9fc] overflow-x-hidden">

                {/* HERO */}
                <div className="bg-gradient-to-r from-[#072F5F] to-[#0B4F9C] py-16 md:py-20">

                    <div className="max-w-7xl mx-auto px-5 md:px-10 text-center">

                        <span className="text-[#D4A017] uppercase tracking-[4px] text-xs md:text-sm font-semibold">

                            School Transport

                        </span>

                        <h1 className="text-4xl md:text-6xl font-extrabold text-white mt-4">

                            {vehicle.title}

                        </h1>

                        <p className="text-gray-200 text-base md:text-lg mt-5">

                            {vehicle.route} Route Details

                        </p>

                    </div>

                </div>

                {/* CONTENT */}
                <div className="max-w-7xl mx-auto px-5 md:px-10 py-16">

                    {/* INFO CARDS */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">

                        {/* DRIVER */}
                        <div className="bg-white rounded-3xl shadow-lg p-8 border border-gray-100">

                            <div className="flex items-center gap-5">

                                <div className="w-16 h-16 rounded-2xl bg-[#0B4F9C]/10 flex items-center justify-center text-[#0B4F9C] text-3xl">

                                    <FaUserTie />

                                </div>

                                <div>

                                    <h3 className="text-xl font-bold text-[#072F5F]">

                                        Driver Name

                                    </h3>

                                    <p className="text-gray-600 mt-2">

                                        {vehicle.driver}

                                    </p>

                                </div>

                            </div>

                        </div>

                        {/* MOBILE */}
                        <div className="bg-white rounded-3xl shadow-lg p-8 border border-gray-100">

                            <div className="flex items-center gap-5">

                                <div className="w-16 h-16 rounded-2xl bg-[#D4A017]/10 flex items-center justify-center text-[#D4A017] text-3xl">

                                    <FaPhoneAlt />

                                </div>

                                <div>

                                    <h3 className="text-xl font-bold text-[#072F5F]">

                                        Mobile Number

                                    </h3>

                                    <p className="text-gray-600 mt-2">

                                        {vehicle.mobile}

                                    </p>

                                </div>

                            </div>

                        </div>

                        {/* BUS */}
                        <div className="bg-white rounded-3xl shadow-lg p-8 border border-gray-100">

                            <div className="flex items-center gap-5">

                                <div className="w-16 h-16 rounded-2xl bg-[#0B4F9C]/10 flex items-center justify-center text-[#0B4F9C] text-3xl">

                                    <FaBusAlt />

                                </div>

                                <div>

                                    <h3 className="text-xl font-bold text-[#072F5F]">

                                        Bus Number

                                    </h3>

                                    <p className="text-gray-600 mt-2">

                                        {vehicle.busNo}

                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                    {/* TRIP TIMING */}
                    <div className="bg-white rounded-3xl shadow-xl p-8 mb-12">

                        <div className="flex items-center gap-4 mb-8">

                            <FaClock className="text-[#0B4F9C] text-4xl" />

                            <h2 className="text-3xl font-bold text-[#072F5F]">

                                Trip Timing

                            </h2>

                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                            <div className="bg-[#f7f9fc] rounded-2xl p-8 text-center border border-gray-100">

                                <h3 className="text-2xl font-bold text-[#072F5F] mb-3">

                                    Morning Trip

                                </h3>

                                <p className="text-lg text-gray-700">

                                    {vehicle.morningTrip}

                                </p>

                            </div>

                            <div className="bg-[#f7f9fc] rounded-2xl p-8 text-center border border-gray-100">

                                <h3 className="text-2xl font-bold text-[#072F5F] mb-3">

                                    Evening Trip

                                </h3>

                                <p className="text-lg text-gray-700">

                                    {vehicle.eveningTrip}

                                </p>

                            </div>

                        </div>

                    </div>

                    {/* TABLE */}
                    <div className="bg-white rounded-3xl shadow-xl overflow-hidden">

                        <div className="bg-gradient-to-r from-[#072F5F] to-[#0B4F9C] px-8 py-6">

                            <div className="flex items-center gap-4">

                                <FaMapMarkerAlt className="text-white text-3xl" />

                                <h2 className="text-3xl font-bold text-white">

                                    Bus Route & Stoppage

                                </h2>

                            </div>

                        </div>

                        <div className="overflow-x-auto">

                            <table className="w-full min-w-[900px]">

                                <thead className="bg-[#D4A017] text-white">

                                    <tr>

                                        <th className="px-6 py-5 text-left text-lg">

                                            S.N.

                                        </th>

                                        <th className="px-6 py-5 text-left text-lg">

                                            Stoppage

                                        </th>

                                        <th className="px-6 py-5 text-left text-lg">

                                            KM

                                        </th>

                                        <th className="px-6 py-5 text-left text-lg">

                                            Morning Time

                                        </th>

                                        <th className="px-6 py-5 text-left text-lg">

                                            Evening Time

                                        </th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {
                                        vehicle.stops.map(
                                            (
                                                item,
                                                index
                                            ) => (

                                                <tr
                                                    key={index}
                                                    className="border-b border-gray-100 hover:bg-[#f7f9fc] transition-all duration-200"
                                                >

                                                    <td className="px-6 py-5 font-bold text-[#0B4F9C]">

                                                        {item.sn}

                                                    </td>

                                                    <td className="px-6 py-5 text-gray-700 font-medium">

                                                        {item.stoppage}

                                                    </td>

                                                    <td className="px-6 py-5 text-gray-700">

                                                        {item.km}

                                                    </td>

                                                    <td className="px-6 py-5 text-gray-700">

                                                        {item.morning}

                                                    </td>

                                                    <td className="px-6 py-5 text-gray-700">

                                                        {item.evening}

                                                    </td>

                                                </tr>
                                            )
                                        )
                                    }

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

            </section>

            <Footer />
        </>
    );
};

export default TransportDetails;